import React, { Component } from "react";
import PropTypes from "prop-types";
import { StaticQuery, graphql } from "gatsby";
import Header from "../components/header";
import Footer from "../components/footer";
import Menu from "../components/menu";
import "./layout.scss";
import SEO from "../components/seo";

class Layout extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isIE: false,
    };
  }

  componentDidMount() {
    if (typeof document !== "undefined") {
      this.setState({
        isIE: /*@cc_on!@*/ false || !!document.documentMode,
      });
    }
  }

  render() {
    let noticeText, buttonText;
    switch (this.props.language) {
      case "da":
        noticeText =
          "For at få den fulde oplevelse med siden anbefales folk, der bruger Internet Explorer, at benytte en nyere browser. Vi anbefaler Google Chrome.";
        buttonText = "Download her";
        break;
      case "sv":
        noticeText =
          "För en bättre upplevelse med vår hemsida rekommenderar vi besökare som använder Internet Explorer att använda en nyare webbläsare. Vi rekommenderar Google Chrome.";
        buttonText = "Ladda ner";
        break;
      case "no":
        noticeText =
          "For å få en bedre opplevelse når du bruker sidene våre anbefaler vi at brukere, som bruker Internett Explorer, benytter en nyere browser. Vi anbefaler Google Chrome.";
        buttonText = "Last ned";
        break;
      case "fi":
        noticeText =
          "Saadaksesi paremman kokemuksen sivustostamme, suosittelemme modernin selaimen käyttöä Internet Explorerin sijasta. Suosittelemme Google Chromea.";
        buttonText = "Lataa";
        break;
    }

    return (
      <div
        className={`wrapper ${this.state.isIE === true ? "wrapper-isIE" : ""}`}
      >
        {this.props.googleTagId
          ? this.props.googleTagId.map((tag) => (
              <noscript key={tag}>
                <iframe
                  src={`https://www.googletagmanager.com/ns.html?id=${tag}`}
                  height="0"
                  width="0"
                  style={{ display: "none", visibility: "hidden" }}
                ></iframe>
              </noscript>
            ))
          : ""}

        <SEO
          title={
            this.props.currentChapter
              ? this.props.currentChapter + " - " + this.props.currentSubChapter
              : this.props.publicationTitle
          }
          keywords={[`Kentico Cloud`, `gatsby`, `application`, `react`]}
          lang={this.props.language}
          description={this.props.description}
          url={this.props.url}
          path={this.props.path}
          canonicalUrl={this.props.canonicalUrl}
          googleTagId={this.props.googleTagId}
          isTest={this.props.isTest}
        />

        {this.state.isIE === true ? (
          <div className="ie-warning">
            <p>{noticeText}</p>
            <p>
              <a
                href="https://www.google.com/chrome/"
                target="_blank"
                rel="noreferrer"
              >
                {buttonText}
              </a>
            </p>
          </div>
        ) : (
          ""
        )}

        <Header
          siteTitle={this.props.siteTitle}
          currentChapter={this.props.currentChapter}
          currentSubChapter={this.props.currentSubChapter}
          currentH2={this.props.currentH2}
          currentH3={this.props.currentH3}
          chapterColor={this.props.chapterColor}
          sticky={this.props.sticky}
          isIndex={this.props.isIndex}
          language={this.props.language}
          type={this.props.pageContext && this.props.pageContext.type}
        />

        {this.props.hasMenu ? (
          <Menu
            publicationCodename={this.props.publicationCodename}
            publicationTitle={this.props.publicationTitle}
            showMenu={this.props.showMenu}
            showButton={this.props.showButton}
            currentChapterCodename={this.props.currentChapterCodename}
            currentH2codename={this.props.currentH2codename}
            language={this.props.language}
          />
        ) : (
          ""
        )}

        <div className="content__container">
          <div
            className={`content${this.props.isIndex ? " content--index" : ""}`}
          >
            {this.props.children}
          </div>

          <Footer language={this.props.language} />
        </div>
      </div>
    );
  }
}

export default ({
  children,
  publicationCodename,
  description,
  publicationTitle,
  showMenu,
  url,
  path,
  canonicalUrl,
  googleTagId,
  showButton,
  hasMenu,
  currentChapterCodename,
  currentChapter,
  currentSubChapter,
  currentH2,
  currentH2codename,
  currentH3,
  chapterColor,
  sticky,
  isIndex,
  language,
  isTest,
  pageContext,
}) => (
  <StaticQuery
    query={graphql`
      {
        site {
          ...SiteInformationFragment
        }
      }
    `}
    render={(data) => (
      <Layout
        siteTitle={data.site.siteMetadata.title}
        children={children}
        publicationCodename={publicationCodename}
        description={description}
        publicationTitle={publicationTitle}
        showMenu={showMenu}
        url={url}
        path={path}
        canonicalUrl={canonicalUrl}
        googleTagId={googleTagId}
        showButton={showButton}
        hasMenu={hasMenu}
        currentChapterCodename={currentChapterCodename}
        currentChapter={currentChapter}
        currentSubChapter={currentSubChapter}
        currentH2={currentH2}
        currentH2codename={currentH2codename}
        currentH3={currentH3}
        chapterColor={chapterColor}
        sticky={sticky}
        isIndex={isIndex}
        language={language}
        isTest={isTest}
        pageContext={pageContext}
      />
    )}
  ></StaticQuery>
);

Layout.propTypes = {
  children: PropTypes.object,
  publicationCodename: PropTypes.string,
  description: PropTypes.string,
  publicationTitle: PropTypes.string,
  showMenu: PropTypes.bool,
  showButton: PropTypes.bool,
  hasMenu: PropTypes.bool,
  currentChapterCodename: PropTypes.string,
  currentChapter: PropTypes.string,
  currentSubChapter: PropTypes.string,
  currentH2: PropTypes.string,
  currentH2codename: PropTypes.string,
  currentH3: PropTypes.string,
  chapterColor: PropTypes.string,
  sticky: PropTypes.bool,
  isIndex: PropTypes.bool,
  url: PropTypes.string,
  path: PropTypes.string,
  canonicalUrl: PropTypes.string,
  googleTagId: PropTypes.array,
  language: PropTypes.string,
  isTest: PropTypes.bool,
  pageContext: PropTypes.object,
};
